interface DisconnectWarningProps {
  onReconnect: () => void
}

export function DisconnectWarning({ onReconnect }: DisconnectWarningProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-40 bg-red-500/10 backdrop-blur-sm border-b border-red-500/30">
      <div className="flex items-center justify-between px-6 py-3">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
          <p className="text-red-200 font-medium">
            Connection lost. Real-time updates are unavailable.
          </p>
        </div>
        <button
          onClick={onReconnect}
          className="px-4 py-1.5 bg-red-500/20 hover:bg-red-500/30 text-red-200 rounded-md text-sm font-medium transition-colors border border-red-500/30"
        >
          Reconnect
        </button>
      </div>
    </div>
  )
}
